import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=75c76924&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=75c76924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c76924",
  null
  
)

export default component.exports